import httpService from "./httpService";

export default {
  tienDoHoanThanhReport(filterForm) {
    return httpService.get("taskReport/tienDoHoanThanhReport", {params: filterForm});
  },
}



// WEBPACK FOOTER //
// ./src/services/taskReportService.js